import React from 'react';
import { useTranslation } from 'react-i18next';

import Seo from '../../../../components/seo';
import useRedirect from '../../../../hooks/redirect';
import { TPageProps } from '../../../../page-props';

function RideHubByDepartmentPage(props: TPageProps) {
  const {
    params: { reference },
    location: { search },
  } = props;
  const { t } = useTranslation();

  useRedirect({ slug: `/rides-hub/departments/${reference}`, search });

  return <Seo isRoot title={t('geovelo.rides_hub.departments_list.title')} {...props} />;
}

export default RideHubByDepartmentPage;
